import Home from './Home'

export const items = [
  {
    path: '/inteligencia-territorial/home',
    name: 'inteligencia-territorial/home',
    component: Home
  }
]



// WEBPACK FOOTER //
// ./src/screens/sala_situacao/config-inteligencia.js